// extracted by mini-css-extract-plugin
export default {"premiumPublicationNews":"styles-module__premiumPublicationNews___joF9z","premiumPublicationNews__title":"styles-module__premiumPublicationNews__title___Mzfs5"};